export default [
    {
        title: "menu.actions.label",
        icon: "ListIcon",
        route: "list-actions",
        action: "list",
        resource: "actions",
    },
]
